import { Switch, Route, Redirect } from "react-router-dom";

import DeluxeHome from "./Pages/Deluxe/Home";
import DeluxeCustom from "./Pages/Deluxe/Custom";
import DeluxePreconfigured from "./Pages/Deluxe/Preconfigured/Preconfigured";

import OfuroHome from "./Pages/Ofuro/Home";
import OfuroCustom from "./Pages/Ofuro/Custom";
import OfuroPreconfigured from "./Pages/Ofuro/Preconfigured/Preconfigured";

import WoodenHome from "./Pages/Wooden/Home"
import WoodenCustom from "./Pages/Wooden/Custom";
import WoodenPreconfigured from "./Pages/Wooden/Preconfigured/Preconfigured";

const App = () => {
    return (
        <Switch>
            <Route exact path="/deluxe-hot-tub">
                <DeluxeHome />
            </Route>
            <Route path="/deluxe-hot-tub/model/:id">
                <DeluxePreconfigured />
            </Route>
            <Route exact path="/deluxe-hot-tub/custom">
                <DeluxeCustom />
            </Route>

            <Route exact path="/ofuro-hot-tub">
                <OfuroHome />
            </Route>
            <Route path="/ofuro-hot-tub/model/:id">
                <OfuroPreconfigured />
            </Route>
            <Route path="/ofuro-hot-tub/custom">
                <OfuroCustom />
            </Route>

            <Route exact path="/wooden-hot-tub">
                <WoodenHome />
            </Route>
            <Route path="/wooden-hot-tub/model/:id">
                <WoodenPreconfigured />
            </Route>
            <Route exact path="/wooden-hot-tub/custom">
                <WoodenCustom />
            </Route>

            <Route path="/">
                <Redirect to="/deluxe-hot-tub" />
            </Route>
        </Switch>
    );
};

export default App;
